export const HOST = [
    'https://ams-auth-us-test.tigerbrokers.net/user',
    'https://oauth.tradeup.com/user',
    'https://ams-auth-us-test.tigerbrokers.net/user'
];

export const API = {
    // 针对个人中心提供的专门接口: https://tigertech.feishu.cn/wiki/wikcnVaEGJoXs5JxX6hKKaihN8L#
    webUserStatus: '/api/v2/web/user/status'
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API['oauth-global']?.GLOBAL;

    if (cfg) {
        HOST.fill(`${cfg}/user`);
    }
}
